var E = /* @__PURE__ */ ((r) => (r.SELF = "_self", r.BLANK = "_blank", r))(E || {}), s = /* @__PURE__ */ ((r) => (r.BUTTON = "button", r.SUBMIT = "submit", r.RESET = "reset", r))(s || {}), S = /* @__PURE__ */ ((r) => (r.SMALL = "small", r.LARGE = "large", r))(S || {}), T = /* @__PURE__ */ ((r) => (r.LEFT = "left", r.CENTER = "center", r))(T || {}), L = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r.TERTIARY = "tertiary", r.SUCCESS = "success", r.ERROR = "error", r.BOTTOM_FIXED = "bottom-fixed", r))(L || {});
export {
  T as RocheUIButtonAlignment,
  L as RocheUIButtonAppearance,
  S as RocheUIButtonSize,
  E as RocheUIButtonTarget,
  s as RocheUIButtonType
};
